var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolidWomen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1015_173",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61245 3.18505C8.02095 3.18505 5.58095 4.10355 6.42945 9.79155C6.44245 9.87755 6.45945 9.97055 6.47695 10.07C6.63195 10.9255 6.87095 12.25 5.34995 13.342C6.38445 14.191 7.85795 15.0395 9.64845 15.407C9.5777 15.8131 9.48895 16.2159 9.38245 16.614C9.23695 17.1481 8.93195 17.5265 8.38695 17.688C7.90695 17.83 7.40395 17.945 6.88895 18.063C6.75645 18.0931 6.62295 18.1236 6.48895 18.1551C5.84645 18.3046 5.19145 18.4701 4.61095 18.7041C4.02895 18.9391 3.48795 19.2556 3.09695 19.7276C2.69895 20.2091 2.48595 20.816 2.50045 21.5751C2.50545 21.8111 2.70745 22 2.95545 22H21.0445C21.2924 22 21.4945 21.8111 21.4995 21.5751C21.514 20.816 21.3015 20.2091 20.903 19.7276C20.5125 19.2556 19.9709 18.9386 19.3895 18.7041C18.8085 18.4695 18.1535 18.304 17.5105 18.1545L17.1115 18.063C16.596 17.945 16.0929 17.83 15.613 17.688C15.068 17.5265 14.763 17.1481 14.6175 16.614C14.4901 16.14 14.389 15.6592 14.3145 15.174C15.6835 14.762 17.1384 14.0215 18.65 12.839L18.643 12.832C17.9334 12.153 16.6035 10.88 16.509 7.85805C16.509 3.69705 13.856 0.0400496 9.61245 3.18505Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1015_173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidWomen);
export default __webpack_public_path__ + "static/media/solid_women.eb10dd93fd3243cadf968fc4bd0d0b85.svg";
export { ForwardRef as ReactComponent };